import { NodeFlags } from "../Const";
import { Draw9GridTextureCmd } from "../display/cmd/Draw9GridTextureCmd";
import { DrawTextureCmd } from "../display/cmd/DrawTextureCmd";
import { DrawTrianglesCmd } from "../display/cmd/DrawTrianglesCmd";
import { Color } from "../maths/Color";
export class ImageRenderer {
    constructor(owner) {
        this._owner = owner;
        this._color = new Color();
    }
    destroy() {
        if (this._tex) {
            if (this._owner._getBit(NodeFlags.EDITING_NODE))
                this._tex.off("reload", this, this.onTextureReload);
            this._tex = null;
        }
        if (this._drawCmd) {
            this._drawCmd.lock = false;
            this._drawCmd.recover();
        }
    }
    setTexture(value) {
        if (this._tex && this._owner._getBit(NodeFlags.EDITING_NODE))
            this._tex.off("reload", this, this.onTextureReload);
        this._tex = value;
        if (value) {
            if (this._owner._getBit(NodeFlags.EDITING_NODE))
                value.on("reload", this, this.onTextureReload);
            this.createCmd();
        }
        else {
            if (this._drawCmd)
                this._drawCmd = this._owner.graphics.replaceCmd(this._drawCmd, null, true);
        }
    }
    setMesh(value) {
        if (this._meshFactory === value) {
            this._owner.graphics.repaint();
            return;
        }
        this._meshFactory = value;
        if (this._tex)
            this.createCmd();
    }
    setColor(value) {
        this._color.parse(value);
        if (this._drawCmd) {
            this._drawCmd.color = this._color.getABGR();
            this._owner.graphics.repaint();
        }
    }
    onTextureReload() {
        var _a;
        (_a = this._onReload) === null || _a === void 0 ? void 0 : _a.call(this);
        this.setTexture(this._tex);
    }
    createCmd() {
        let drawClass;
        if (this._meshFactory)
            drawClass = DrawTrianglesCmd;
        else if (this._tex._sizeGrid)
            drawClass = Draw9GridTextureCmd;
        else
            drawClass = DrawTextureCmd;
        if (this._drawCmd && this._drawCmd.cmdID === drawClass.ID) {
            this._drawCmd.texture = this._tex;
            if (drawClass === DrawTrianglesCmd)
                this._drawCmd.mesh = this._meshFactory;
            else if (drawClass === Draw9GridTextureCmd)
                this._drawCmd.sizeGrid = this._tex._sizeGrid;
            this._owner.graphics.repaint();
            return;
        }
        let cmd;
        if (this._meshFactory)
            cmd = DrawTrianglesCmd.create2(this._tex, this._meshFactory);
        else if (this._tex._sizeGrid)
            cmd = Draw9GridTextureCmd.create(this._tex, 0, 0, 1, 1, this._tex._sizeGrid, true);
        else
            cmd = DrawTextureCmd.create(this._tex, 0, 0, 1, 1, null, 1, null, null, null, true);
        cmd.lock = true;
        cmd.color = this._color.getABGR();
        this._drawCmd = this._owner.graphics.replaceCmd(this._drawCmd, cmd, true);
    }
}
